export default function HowItWorks() {
  return (
    <section className="how-section" id="how">
      <div className="container">
        <div className="section-header">
          <span className="section-label">Jak to funguje</span>
          <h2>Od podpisu po první sync za 48 hodin</h2>
          <p>Žádné měsíce implementace. Žádné školení na 3 dny. Tři kroky a jedete.</p>
        </div>
        <div className="how-steps">
          <div className="how-step">
            <div className="step-number" style={{ background: 'var(--accent-soft)', border: '2px solid var(--accent)', color: 'var(--accent)' }}>1</div>
            <div className="step-duration" style={{ color: 'var(--accent)', background: 'var(--accent-soft)' }}>30 min</div>
            <h3 className="step-title">Konzultace zdarma</h3>
            <p className="step-desc">Zavoláme si. Probereme, jaké systémy používáte a co potřebujete. Navrhneme řešení přímo na míru.</p>
          </div>
          <div className="how-step">
            <div className="step-number" style={{ background: 'var(--gold-soft)', border: '2px solid var(--gold)', color: 'var(--gold)' }}>2</div>
            <div className="step-duration" style={{ color: 'var(--gold)', background: 'var(--gold-soft)' }}>24–48 h</div>
            <h3 className="step-title">Nastavíme vše za vás</h3>
            <p className="step-desc">Propojíme vaše systémy, nastavíme mapování dat, ověříme účetní předkontace. Otestujeme na reálných datech.</p>
          </div>
          <div className="how-step">
            <div className="step-number" style={{ background: 'var(--green-soft)', border: '2px solid var(--green)', color: 'var(--green)' }}>3</div>
            <div className="step-duration" style={{ color: 'var(--green)', background: 'var(--green-soft)' }}>&infin;</div>
            <h3 className="step-title">Data tečou. Vy řídíte.</h3>
            <p className="step-desc">Doklady se synchronizují automaticky. Vy jen kontrolujete v portálu. Kdyby cokoliv, jsme na telefonu.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
